import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { EmvioLoadingSpinner as LoadingSpinner } from '@nexio/emvio-util-ui';
import {
    EmvioValidatedInput,
    EmvioValidatedButton,
    EmvioValidatedForm
} from '@nexio/emvio-form-components';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';
import { get } from 'lodash';

import { updateUser as updateSelf } from '../UserSettings/userSettingsActions';
import {
    getSelf,
    getIsLoading as getIsSelfLoading,
    getErrorMessage as getSelfErrorMessage,
    getIsUpdateSuccess as getIsSelfUpdateSuccess
} from '../Self/selfEntity';
import { historyShape, selfShape } from '../../utils/propTypes';

export class UserSetup extends Component {
    static propTypes = {
        history: historyShape,
        isSelfLoading: PropTypes.bool,
        selfErrorMessage: PropTypes.string,
        onUpdateSelf: PropTypes.func,
        self: selfShape,
        isSelfUpdateSuccess: PropTypes.bool
    };

    state = {
        email: get(this.props.self, 'userName', ''),
        firstName: '',
        lastName: '',
        phone: ''
    };

    componentDidUpdate(prevProps) {
        if (doesPropExistAndHasItChanged(prevProps, this.props, 'selfErrorMessage')) {
            this.props.history.replace('/');
        }

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'isSelfUpdateSuccess')) {
            const self = get(this.props, 'self');

            if (get(self, 'firstName') && get(self, 'lastName')) {
                if (this.props.self.accountType === 'RESELLER') {
                    this.props.history.replace('/home');
                } else {
                    this.props.history.replace('/dashboard');
                }
            }

            this.setState({
                email: self.userName ? self.userName : '',
                firstName: self.firstName ? self.firstName : '',
                lastName: self.lastName ? self.lastName : '',
                phone: self.phone ? self.phone : ''
            });
        }
    }

    onUpdateFirstName = (e) => {
        this.setState({
            firstName: e.target.value
        });
    };

    onUpdateLastName = (e) => {
        this.setState({
            lastName: e.target.value
        });
    };

    onUpdatePhone = (e) => {
        this.setState({
            phone: e.target.value
        });
    };

    onSubmit = () => {
        let updatedSelf = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            phone: this.state.phone ? this.state.phone : null,
            notifications: get(this.props.self, 'notifications') ? get(this.props.self, 'notifications') : {
                chargebacks: true,
                fraud: true,
                largeExports: true,
                payoutBatches: true
            }
        };
        this.props.onUpdateSelf(updatedSelf);
    };

    render() {
        if (!this.props.self) {
            return <LoadingSpinner />;
        }

        return (
            <EmvioValidatedForm className="emvio-user-setup emvio-login" onSubmit={this.onSubmit}>
                {
                    this.props.isSelfLoading &&
                    <LoadingSpinner />
                }
                {
                    !this.props.isSelfLoading &&
                    <div className="login-container" >
                        <div className="logo" />
                        <div className="login-form">
                            <EmvioValidatedInput
                                autoCapitalize="off"
                                autoCorrect="off"
                                disabled
                                labelText="EMAIL"
                                name="email"
                                onChange={() => { }}
                                placeholder="Email Address"
                                shouldEnforceLowerCase
                                type="text"
                                validations={['email', 'required']}
                                value={this.state.email}
                            />
                            <EmvioValidatedInput
                                autoCapitalize="off"
                                autoCorrect="off"
                                autoFocus
                                labelText="FIRST NAME"
                                name="firstName"
                                onChange={this.onUpdateFirstName}
                                shouldNotTrim
                                type="text"
                                validations={['required']}
                                value={this.state.firstName}
                            />
                            <EmvioValidatedInput
                                autoCapitalize="off"
                                autoCorrect="off"
                                labelText="LAST NAME"
                                name="lastName"
                                onChange={this.onUpdateLastName}
                                shouldNotTrim
                                type="text"
                                validations={['required']}
                                value={this.state.lastName}
                            />
                            <EmvioValidatedInput
                                inputWrapperClassName="phone-input"
                                autoCapitalize="off"
                                autoCorrect="off"
                                labelText="PHONE"
                                name="phone"
                                onChange={this.onUpdatePhone}
                                shouldEnforcePhone
                                type="text"
                                validations={['phoneNumber']}
                                value={this.state.phone}
                            />
                            <EmvioValidatedButton isLoading={this.props.isSelfLoading}>
                                Save
                            </EmvioValidatedButton>
                        </div>
                    </div>
                }
            </EmvioValidatedForm>
        );
    }
}

export function mapStateToProps(state) {
    return {
        isSelfLoading: getIsSelfLoading(state),
        selfErrorMessage: getSelfErrorMessage(state),
        self: getSelf(state),
        isSelfUpdateSuccess: getIsSelfUpdateSuccess(state)
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        onUpdateSelf: (self) => dispatch(updateSelf(self))
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserSetup));
